import { ISafegraphLocation } from "./ISafegraphLocation";
import { IPolygon } from "./Models";

export interface IGCPBigQueryJob {
  id: number;
  projectId: string;
  datasetId: string;
  tableId: string;
  jobId: string;
  jobType: string;
  status: string;
  title: string;
  totalBytesProcessed: number;
  jobStartEpoch: number;
  jobEndEpoch: number;
  jobPolygon: IPolygon;
  cid: number;
  uid: number;
  cacheUrl: string;
  createdDateTime: Date;
  modifiedDateTime: Date;
  queryFromDateTime: Date;
  queryToDateTime: Date;
  viewInScout: boolean;
  milesLessOrGreater: string;
  miles: number;
  mobilyticsPlace: ISafegraphLocation;
}
